import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {UnsavedChangesComponent} from "./unsaved-changes-component";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class UnsavedChangesGuard  {

  constructor(private _translateService: TranslateService) {

  }

  canDeactivate(component: UnsavedChangesComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (component.isDirty()) {
      let message = '';
      this._translateService.get('There are unsaved changes. Are you sure you want to leave this page?')
        .subscribe((res: string) => {
          message = res;
        });
      //do not wait for translation, the confirm - cancel will not work anymore
      return confirm(message);

    }
    return true;
  }

}
